import tegIcon from "@/ui/assets/teg-icon.png";
import { cn } from "@/nucleo/utilitarios";
import * as React from "react";

interface TegLogoProps {
  size?: "sm" | "md";
  className?: string;
}

export const TegLogo = React.forwardRef<HTMLDivElement, TegLogoProps>(function TegLogo(
  { size = "md", className },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        "rounded-xl bg-primary flex items-center justify-center shrink-0",
        size === "sm" ? "h-9 w-9" : "h-10 w-10",
        className,
      )}
    >
      <img
        src={tegIcon}
        alt="TEG"
        className={cn("object-contain", size === "sm" ? "h-6 w-6" : "h-7 w-7")}
      />
    </div>
  );
});
